function getTimeRemaining(endtime) {
  const total = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) );//% 24);
  //const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    total,
    //days,
    hours,
    minutes,
    seconds,
  };
}

function initializeClock(id, endtime) {
  const clock = document.getElementById(id);
  if (clock === null) {
    return;
  }
  //const daysSpan = clock.querySelector(".days");
  const hoursSpan = clock.querySelector(".hours");
  const minutesSpan = clock.querySelector(".minutes");
  const secondsSpan = clock.querySelector('.seconds');

  function updateClock() {
    const t = getTimeRemaining(endtime);

    //daysSpan.innerHTML = t.days;
    hoursSpan.innerHTML = ("0" + t.hours).slice(-2);
    minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

    if (t.total <= 0) {
      clearInterval(timeinterval);
      clock.style.display = "none";
    }
  }

  updateClock();
  const timeinterval = setInterval(updateClock, 1000);
}

const deadline = "03 Dec 2024 00:00:01 GMT+0100";
//initializeClock("clockdiv", deadline);

window.onload = function () {
  const filterProxyTen = document.getElementById("filter10");
  const filterProxyFifteen = document.getElementById("filter15");
  const filterProxyTwenty = document.getElementById("filter20");
  const filterProxyThirty = document.getElementById("filter30");

  if (filterProxyTen != null) {
    filterProxyTen.onclick = function () {
      let filterTen = document.getElementById(
        "drawer-filter-p-m-custom-black_week-10"
      );
      let filterFifteen = document.getElementById(
        "drawer-filter-p-m-custom-black_week-15"
      );
      let filterTwenty = document.getElementById(
        "drawer-filter-p-m-custom-black_week-20"
      );
      let filterThirty = document.getElementById(
        "drawer-filter-p-m-custom-black_week-30"
      );
      if (filterFifteen != null) {
        filterFifteen.checked = false;
      }
      if (filterTwenty != null) {
        filterTwenty.checked = false;
      }
      if (filterThirty != null) {
        filterThirty.checked = false;
      }
      if (filterTen != null) {
        filterTen.click();
      }
      console.log("test3");
      return false;
    };
  }
  if (filterProxyFifteen != null) {
    filterProxyFifteen.onclick = function () {
      let filterTen = document.getElementById(
        "drawer-filter-p-m-custom-black_week-10"
      );
      let filterFifteen = document.getElementById(
        "drawer-filter-p-m-custom-black_week-15"
      );
      let filterTwenty = document.getElementById(
        "drawer-filter-p-m-custom-black_week-20"
      );
      let filterThirty = document.getElementById(
        "drawer-filter-p-m-custom-black_week-30"
      );
      if (filterTen != null) {
        filterTen.checked = false;
      }
      if (filterTwenty != null) {
        filterTwenty.checked = false;
      }
      if (filterThirty != null) {
        filterThirty.checked = false;
      }
      if (filterFifteen != null) {
        filterFifteen.click();
      }
      return false;
    };
  }
  if (filterProxyTwenty != null) {
    filterProxyTwenty.onclick = function () {
      let filterTen = document.getElementById(
        "drawer-filter-p-m-custom-black_week-10"
      );
      let filterFifteen = document.getElementById(
        "drawer-filter-p-m-custom-black_week-15"
      );
      let filterTwenty = document.getElementById(
        "drawer-filter-p-m-custom-black_week-20"
      );
      let filterThirty = document.getElementById(
        "drawer-filter-p-m-custom-black_week-30"
      );
      if (filterTen != null) {
        filterTen.checked = false;
      }
      if (filterFifteen != null) {
        filterFifteen.checked = false;
      }
      if (filterThirty != null) {
        filterThirty.checked = false;
      }
      if (filterTwenty != null) {
        filterTwenty.click();
      }
      return false;
    };
  }
  if (filterProxyThirty != null) {
    filterProxyThirty.onclick = function () {
      let filterTen = document.getElementById(
        "drawer-filter-p-m-custom-black_week-10"
      );
      let filterFifteen = document.getElementById(
        "drawer-filter-p-m-custom-black_week-15"
      );
      let filterTwenty = document.getElementById(
        "drawer-filter-p-m-custom-black_week-20"
      );
      let filterThirty = document.getElementById(
        "drawer-filter-p-m-custom-black_week-30"
      );
      if (filterTen != null) {
        filterTen.checked = false;
      }
      if (filterFifteen != null) {
        filterFifteen.checked = false;
      }
      if (filterTwenty != null) {
        filterTwenty.checked = false;
      }
      if (filterThirty != null) {
        filterThirty.click();
      }
      return false;
    };
  }
};

/*!
 * Snowfall.js v1.1 (http://cople.github.io/Snowfall.js/)
 *
(function(window, document, undefined) {

    "use strict";

    var winWidth = window.innerWidth,
        winHeight = window.innerHeight,
        defaultOptions = {
            minSize: 10,
            maxSize: 30,
            type: "text",
            content: "&#10052",
            fadeOut: true,
            autoplay: true,
            interval: 200
        };

    function cssPrefix(propertyName) {
        var capitalizePropertyName = propertyName.charAt(0).toUpperCase() + propertyName.slice(1),
            tempDiv = document.createElement("div"),
            style = tempDiv.style,
            vendorPrefixes = ["Webkit", "Moz", "ms", "O"];

        if (propertyName in style) return propertyName;

        for (var i = 0, l = vendorPrefixes.length; i < l; i++) {
            var name = vendorPrefixes[i] + capitalizePropertyName;
            if (name in style) return name;
        };

        return null;
    };

    var cssPrefixedNames = {
            "transform": cssPrefix("transform"),
            "transition": cssPrefix("transition")
        },
        transitionendEventName = {
            "WebkitTransition": "webkitTransitionEnd",
            "OTransition": "oTransitionEnd",
            "Moztransition": "transitionend",
            "transition": "transitionend"
        }[cssPrefixedNames.transition];

    function random(min, max, deviation) {
        if (deviation) {
            deviation *= max;
            max = max + deviation;
            min = max - deviation;
        } else {
            min = min || 0;
        };
        return parseInt(Math.random() * (max - min + 1) + min);
    };

    function extend(target, source) {
        for (var prop in source) {
            target[prop] = source[prop];
        };
        return target;
    };

    function setStyle(element, rules) {
        for (var name in rules) {
            element.style[cssPrefixedNames[name] || name] = rules[name];
        };
    };

    var hidden, visibilityChange;
    if (typeof document.hidden !== "undefined") {
        hidden = "hidden";
        visibilityChange = "visibilitychange";
    } else if (typeof document.mozHidden !== "undefined") {
        hidden = "mozHidden";
        visibilityChange = "mozvisibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
    };

    window.addEventListener("resize", function() {
        winHeight = window.innerHeight;
        winWidth = window.innerWidth;
    }, false);

    function Snowfall(newOptions) {

        var _ = this,
            queue = [],
            options = defaultOptions,
            $snowfield = document.createElement("div"),
            isImage, cntLength, $snowflake, timer;

        _.config = function(newOptions) {
            extend(options, newOptions);

            isImage = options.type == "image";
            cntLength = options.content.length;

            $snowflake = isImage ? new Image() : document.createElement("div");
            $snowflake.className = "snowflake snowflake-" + options.type;
            $snowflake.dataset.type = options.type;
        };

        _.config(newOptions);

        function Snowflake() {
            var _$snowflake = $snowflake.cloneNode();
            if (options.type != "solid") {
                _$snowflake[isImage ? "src" : "innerHTML"] = typeof options.content == "string" ? options.content : options.content[cntLength == 0 ? 0 : Math.floor(Math.random() * cntLength)];
            };

            return _$snowflake;
        };

        function snowAnimate() {
            var size = random(options.minSize, options.maxSize),
                top = -2 * size,
                left = random(0, winWidth - size),
                opacity = random(5, 10) / 10,
                angle = random(null, winHeight * 0.8, 1),
                translateX = random(-100, 100),
                translateY = winHeight + size * 2,
                duration = random(null, winHeight * 20, 0.2),
                _$snowflake;

            if (queue.length) {
                _$snowflake = queue.shift();
                if (_$snowflake.dataset.type != options.type) _$snowflake = new Snowflake();
            } else {
                _$snowflake = new Snowflake();
            };

            var styleRules = {
                "top": top + "px",
                "left": left + "px",
                "opacity": opacity,
                "transform": "none",
                "transition": duration + "ms linear"
            };

            switch (options.type) {
                case "solid":
                    styleRules.width = styleRules.height = size + "px";
                    break;
                case "text":
                    styleRules["font-size"] = size + "px";
                    break;
                case "image":
                    styleRules.width = size + "px";
                    break;
            };

            setStyle(_$snowflake, styleRules);

            $snowfield.appendChild(_$snowflake);

            setTimeout(function() {
                setStyle(_$snowflake, {
                    "transform": "translate(" + translateX + "px," + translateY + "px) rotate(" + angle + "deg)",
                    "opacity": options.fadeOut ? 0 : opacity
                });
            }, 100);
        };

        _.playing = 0;

        _.play = function() {
            if (_.playing) return;
            timer = setInterval(snowAnimate, options.interval);
            _.playing = 1;
        };

        _.stop = function() {
            if (!_.playing) return;
            clearInterval(timer);
            timer = null;
            _.playing = 0;
        };

        document.addEventListener(visibilityChange, function() {
            document[hidden] ? _.stop() : _.play();
        }, false);

        $snowfield.addEventListener(transitionendEventName, function(e) {
            var snowflake = e.target || e.srcElement;
            $snowfield.removeChild(snowflake);
            queue.push(snowflake);
        }, false);

        $snowfield.className = "snowfield";
        document.body.appendChild($snowfield);

        options.autoplay && _.play();

        return _;
    };

    window.Snowfall = Snowfall;

})(window, document);


var snow = new Snowfall();
snow.config({
    minSize: 10,
    maxSize: 30,
    type: "image",
    content: ["/cdn/shop/t/8/assets/Schneeflocke-mint.svg","/cdn/shop/t/8/assets/Schneeflocke-petrol.svg"],
    fadeOut: true,
    autoplay: true,
    interval: 100
});
//snow.play();*/

const swiper = new Swiper(".swiper", {
  navigation: {
    enabled: false,
  },
  pagination: {
    enabled: true,
  },
  scrollbar: {
    enabled: false,
  },
  freeMode: {
    enabled: true,
  },
  // Default parameters
  slidesPerView: 2,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 5,
      spaceBetween: 40,
    },
    640: {
      slidesPerView: 6,
      spaceBetween: 50,
    },
    // when window width is >= 640px
    1290: {
      slidesPerView: 7,
      spaceBetween: 60,
      pagination: {
        enabled: false,
      },
    },
  },
});
